module.exports = __webpack_public_path__ + "img/credit-card.47905ede.svg";